import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=6433593a&scoped=true&"
import script from "./Level.vue?vue&type=script&lang=ts&"
export * from "./Level.vue?vue&type=script&lang=ts&"
import style0 from "./Level.vue?vue&type=style&index=0&id=6433593a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6433593a",
  null
  
)

export default component.exports